import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    private subject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public authenticationState: Observable<boolean> = this.subject.asObservable();

    constructor() { }

    public updateAuthenticationState(isAuthenticated: boolean) {
        if (this.subject.value != isAuthenticated) {
            this.subject.next(isAuthenticated);
        }
    }

}
